<form *ngIf="customInputFormGroup" [formGroup]="customInputFormGroup" class="flange-form-main">
    <app-standard [form]="customInputFormGroup" [isCustom]="isCustom"></app-standard>

    <app-pipe-size [form]="customInputFormGroup" [isCustom]="isCustom"></app-pipe-size>

    <app-flange-type [form]="customInputFormGroup" [isCustom]="isCustom"></app-flange-type>

    <app-flange-facing-type [form]="customInputFormGroup" [flangeTypeId]="flangeTypeId"></app-flange-facing-type>

    <app-flange-material class="input-wrapper-list" [form]="customInputFormGroup" [isCustom]="isCustom"></app-flange-material>

    <app-gasket
        class="input-wrapper-list"
        [form]="customInputFormGroup"
        [flangeFacingTypeId]="flangeFacingTypeId"
        [isCustom]="isCustom"
        [isStandardFlange]="false"
        [isRTJ]="isRTJ"
        [doGasketReset]="doGasketReset"
    ></app-gasket>

    <app-bolt-type [form]="customInputFormGroup" (selected)="onSelectedBoltType($event)"></app-bolt-type>

    <app-thread-type-bolt-size [form]="customInputFormGroup" [boltType]="boltType" (selected)="onSelectedBoltSize($event)"></app-thread-type-bolt-size>

    <app-bolt-quantity [form]="customInputFormGroup"></app-bolt-quantity>

    <app-reduced-area-bolting [form]="customInputFormGroup"></app-reduced-area-bolting>

    <app-nut-standard [form]="customInputFormGroup" [boltDimensionId]="boltDimensionId"></app-nut-standard>

    <app-bolt-material class="input-wrapper-list" [form]="customInputFormGroup" [isCustom]="isCustom"></app-bolt-material>

    <app-pipe-schedule [form]="customInputFormGroup" [isCustom]="isCustom"></app-pipe-schedule>

    <app-washers [form]="customInputFormGroup"></app-washers>

    <app-additional-component [form]="customInputFormGroup"></app-additional-component>

    <app-tightening-specification [form]="customInputFormGroup" [calculationType]="calculationType"></app-tightening-specification>

    <app-rec-gasket-stress [form]="customInputFormGroup"></app-rec-gasket-stress>

    <app-min-gasket-stress [form]="customInputFormGroup"></app-min-gasket-stress>

    <app-max-gasket-stress [form]="customInputFormGroup"></app-max-gasket-stress>

    <app-y [form]="customInputFormGroup"></app-y>

    <app-m [form]="customInputFormGroup"></app-m>

    <div *ngIf="tighteningMethod == 1">
        <app-padditional [form]="customInputFormGroup"></app-padditional>
    </div>

    <div *ngIf="idmsSharedService.enableConfirmWithRouter(1)">
        <a href="javascript:void(0)" class="btn font-weight-bold py-3 px-6 secondary-ebtn informateFullWidth" (click)="btnCustomInputConfirmClicked()">
            {{ 'STANDARD_FLANGE_PAGE.BUTTONS_TEXT.CONFIRM' | transloco }}
        </a>
    </div>
</form>
